import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import CardComponent from "../../../shared/components/Card/CardComponent";
import Filter from "../../../shared/components/Filter/ui/Filter";
import { fetchProperties, clearProperties } from "../model/propertiesSlice";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import SkipPrevious from "@mui/icons-material/SkipPrevious";
import { toast } from "react-toastify";
import s from "../styles.module.css";
import { endpointMap } from "../../../data/Fields";
import useAuth from "../../../hooks/useAuth";

const buttons = [
  {
    title: "Срочный вариант",
    background: "rgba(245, 212, 221, 1)",
    color: "rgba(218, 86, 119, 1)",
  },
  {
    title: "Эксклюзивный договор",
    background: "rgba(251, 236, 205, 1)",
    color: "rgba(241, 179, 55, 1)",
  },
  {
    title: "Выкупной вариант",
    background: "rgba(208, 228, 247, 1)",
    color: "rgba(67, 148, 224, 1)",
  },
  {
    title: "Без рекламы",
    background: "rgba(209, 239, 206, 1)",
    color: "rgba(73, 191, 62, 1)",
  },
];

const General = () => {
  const dispatch = useDispatch();
  const { auth } = useAuth();
  const token = auth?.access_token;
  const { data, pageSize, total, totalPages, status } = useSelector(
    (state) => state.properties,
  );
  const { loading, results } = useSelector((state) => state.filter);

  const [searchParams, setSearchParams] = useSearchParams();

  // Extract current page – default 1
  const currentPage = parseInt(searchParams.get("page") || "1", 10);

  // Extract filters from URL if present
  const filtersFromUrl = searchParams.get("filters")
    ? JSON.parse(searchParams.get("filters"))
    : {};

  // Fetch data whenever URL parameters change
  useEffect(() => {
    dispatch(
      fetchProperties({
        token,
        page: currentPage,
        pageSize,
        ...filtersFromUrl,
      }),
    );
  }, [searchParams, token, pageSize, dispatch]);

  // Page change: create a new URLSearchParams instance to avoid mutation
  const handlePageChange = (newPage) => {
    setSearchParams((prev) => {
      const nextParams = new URLSearchParams(prev);
      nextParams.set("page", newPage.toString());
      return nextParams;
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const onSubmit = async (formData) => {
    const params = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (value) {
        if (key === "property_type") {
          if (value === "Дома и участки") {
            params[key] = "дома";
          } else if (endpointMap[value]) {
            params[key] = value.toLowerCase();
          } else {
            params[key] = value;
          }
        } else if (key === "property_id") {
          params["property_id"] = value;
        } else if (key === "agents") {
          params["agent_id"] = value;
        } else if (key === "property_condition") {
          params[key] = value.toLowerCase();
        } else if (key === "transaction_type") {
          params[key] = value.toLowerCase();
        } else if (key === "land_type") {
          params[key] = value.toLowerCase();
        } else {
          params[key] = value;
        }
      }
    });

    // Reset to page 1 and store filters
    setSearchParams({
      page: "1",
      filters: JSON.stringify(params),
    });

    dispatch(fetchProperties({ token, page: 1, pageSize, ...params }))
      .unwrap()
      .then((result) => {
        if (!result.data || result.data.length === 0) {
          toast.info("Нет данных по вашему запросу.");
        } else {
          toast.success("Поиск завершен!");
        }
      })
      .catch((error) => toast.error(error));
  };

  const onClear = () => {
    dispatch(clearProperties());
    setSearchParams({ page: "1" }); // remove filters, reset to page 1
    dispatch(fetchProperties({ token, page: 1, pageSize }));
    toast.info("Фильтры сброшены");
  };

  const PaginationControls = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 20,
        marginTop: "20px",
        marginBottom: "15px",
      }}
    >
      <button
        disabled={currentPage === 1}
        onClick={() => handlePageChange(currentPage - 1)}
        style={{ cursor: "pointer" }}
      >
        <SkipPrevious />
      </button>
      <span>
        {currentPage} из {totalPages}
      </span>
      <button
        disabled={currentPage === totalPages}
        onClick={() => handlePageChange(currentPage + 1)}
        style={{ cursor: "pointer" }}
      >
        <SkipNextIcon />
      </button>
    </div>
  );

  return (
    <div className="container">
      <Filter
        onSubmit={onSubmit}
        onClear={onClear}
        results={results}
        loading={loading}
      />
      <h1
        style={{
          color: "rgba(19, 19, 19, 0.7)",
          fontSize: 16,
          fontWeight: 500,
          marginBottom: 30,
          textAlign: "center",
        }}
      >
        Показано {(currentPage - 1) * pageSize + 1} –{" "}
        {Math.min(currentPage * pageSize, total)} из {total}
      </h1>

      <PaginationControls />

      <div className={s.cardBlock}>
        {status === "loading" ? (
          <div className={s.loadingWrapper}>
            <div className="loader"></div>
          </div>
        ) : data && data.length > 0 ? (
          data.map((item) => (
            <CardComponent key={item.id} item={item} buttons={buttons} />
          ))
        ) : (
          <p>Нет данных</p>
        )}
      </div>

      <PaginationControls />
    </div>
  );
};

export default General;
